'use strict';

import { Buildings, isMobile, projectMode, settingsData } from '../../settings';
import { createHtmlElement, userPrevent } from '../../functions';
import { isDesktopMode } from '../language/langSwitcher';
import {UnitCardClass} from "../cards/unitCards/UnitCardClass";
import gsap from 'gsap';
import {enableOrbitControls} from "../controls/orbitControls";

export class FloorSlider {
    constructor (container) {
        this.container = container;
        this.rightNavBar = document.querySelector('.right-nav-bar');
        this.floors = [];
        this.isScrolling = null;
        this.slider = null;
        this.leader = null;
        this.maxFloorBtn = null;
        this.minFloorBtn = null;
        this.maxSeparator = null;
        this.minSeparator = null;
        this.blockFloorSLider = false;
        this.fsTop = 0;
        this.leaderHeight = 0;
        this.floorBtnHeight = 0;
        this.floorBtnHalfHeight = 0;
        this.staticBtnHeight = 0;
        this.fsMargin = 50;
        this.plugHeight = 0;
        this.scrollHandler = null;
        this.clickHandler = null;
        this.separatorHandler = null;
        this.visibleBtnsCount = 5;
    }

    create(){
        const activeBuilding = Buildings.getActiveBuilding();
        this.floors = activeBuilding.getFloorNumbersForFloorSlider();

        this.slider = createHtmlElement(this.container,'','div',['fs__main__container']);
        this.maxFloorBtn = createHtmlElement(this.slider,'','button',['fs__static__floor','fs__max__floor']);
        this.maxSeparator = createHtmlElement(this.slider,'','div',['leader__separator','max__separator','icon-more']);
        this.leader = createHtmlElement(this.slider,'','ul',['fs__leader']);

        this.floors.forEach(floor =>{
            const floorNum = createHtmlElement(this.leader,floor,'li',['fs__floor__number']);
            floorNum.setAttribute('data-floor',floor);
        });

        const max = Math.max(...this.floors);
        const min = Math.min(...this.floors);
        this.maxFloorBtn.textContent = max;

        this.fsTop = this.slider.getBoundingClientRect().top;

        this.calculateHeight();

        this.minSeparator = createHtmlElement(this.slider,'','div',['leader__separator','min__separator','icon-more']);
        this.minFloorBtn = createHtmlElement(this.slider,min,'button',['fs__static__floor','fs__min__floor']);

        const plug = createHtmlElement('','','li',['fs__plug']);
        this.leader.insertAdjacentElement('afterbegin',plug);
        this.leader.appendChild(plug.cloneNode());

        // const center = createHtmlElement(this.slider,'','div',['fs__center']);

        this.click(this.getFloorBtn(settingsData.currentFloor));

        this.scrollHandler = this.scroll.bind(this);
        this.clickHandler = this.click.bind(this);
        this.separatorHandler = this.jump.bind(this);

        this.leader.addEventListener('scroll', this.scrollHandler);
        this.leader.addEventListener('click',this.clickHandler);

        this.maxSeparator.addEventListener('click',this.separatorHandler);
        this.minSeparator.addEventListener('click',this.separatorHandler);

        this.maxFloorBtn.addEventListener('click', () => this.click(this.getFloorBtn(this.floors[0])));
        this.minFloorBtn.addEventListener('click', () => this.click(this.getFloorBtn(this.floors[this.floors.length - 1])));

    }

    calculateHeight() {
        if (!this.slider) return;

        let usePreset;
        let totalHeight;
        let presetTotalHeight;
        let separator;

        const presetMobile = {
            portrait: {
                menu: this.getElementHeight('additional-menu__container'),
                card: this.getElementHeight('unit-card'),
                bottomNavBar: this.getElementHeight('bottom__nav-bar'),
                search: this.getElementHeight('search__container-main.mobile')
            },
            landscape: {
                total: 0
            }

        };

        const presetWeb = {
            bottomNavBar: this.getElementHeight('bottom__nav-bar')
        };


        if (isMobile) {

            if (settingsData.isLandscape){
                this.rightNavBar.classList.add('fs-slider-open');

                usePreset = presetMobile.landscape;
                presetTotalHeight = Math.max(...Object.values(usePreset));

                this.fsTop = 0;

                totalHeight = Math.ceil(window.innerHeight - this.fsTop - presetTotalHeight - this.fsMargin);

                this.staticBtnHeight = 0;
                this.floorBtnHeight = (totalHeight - this.staticBtnHeight * 2) / (this.visibleBtnsCount);
                this.floorBtnHalfHeight = Math.ceil(this.floorBtnHeight / 2);
                this.leaderHeight = totalHeight;

            } else {
                usePreset = presetMobile.portrait;
                presetTotalHeight = Math.max(...Object.values(usePreset));
                separator = this.maxSeparator.getBoundingClientRect().height * 2;
                this.fsTop = this.slider.getBoundingClientRect().top - this.fsMargin / 2;

                totalHeight = Math.ceil(window.innerHeight - this.fsTop - presetTotalHeight - this.fsMargin - separator);

                this.staticBtnHeight = totalHeight / this.visibleBtnsCount + 2;
                this.floorBtnHeight = (totalHeight - this.staticBtnHeight * 2) / (this.visibleBtnsCount);
                this.floorBtnHalfHeight = Math.ceil(this.floorBtnHeight / 2);
                this.leaderHeight = totalHeight - this.staticBtnHeight * 2;

            }

        } else {
            usePreset = presetWeb;
            presetTotalHeight = Math.max(...Object.values(usePreset));
            separator = this.maxSeparator.getBoundingClientRect().height * 2;

            if (isDesktopMode()){
                this.slider.classList.add('floor-slider__desktop');
                presetTotalHeight += document.querySelector('.aside__logo').getBoundingClientRect().height ;
                this.fsTop = 0;
            }

            totalHeight = Math.ceil(window.innerHeight - this.fsTop - presetTotalHeight - this.fsMargin - separator);

            this.staticBtnHeight = totalHeight / this.visibleBtnsCount + 2;
            this.floorBtnHeight = (totalHeight - this.staticBtnHeight * 2) / (this.visibleBtnsCount);
            this.floorBtnHalfHeight = Math.ceil(this.floorBtnHeight / 2);
            this.leaderHeight = totalHeight - this.staticBtnHeight * 2;
        }

        this.plugHeight =  this.leaderHeight / 2 - this.floorBtnHalfHeight;

        document.documentElement.style.setProperty('--fsBtnHeight', `${this.floorBtnHeight}px`);
        document.documentElement.style.setProperty('--fsBtnHeightHalf', `${this.floorBtnHalfHeight}px`);
        document.documentElement.style.setProperty('--fsPlugHeight', `${this.plugHeight}px`);
        document.documentElement.style.setProperty('--fsLeaderHeight', `${this.leaderHeight}px`);
        document.documentElement.style.setProperty('--fsMargin', `${this.fsMargin / 2}px`);
        document.documentElement.style.setProperty('--fsStaticBtnHeight', `${this.staticBtnHeight}px`);
    }

    resize(){
        if (!this.slider) return;

        this.calculateHeight();
        const floorBtn = this.getFloorBtn(settingsData.currentFloor);
        const scrollDiff = this.leader.scrollTop + this.plugHeight - floorBtn.offsetTop;

        this.setActiveFloorNumber();
        this.setActiveFloorNumber(floorBtn);

        gsap.to(this.leader,{
            duration: .3,
            scrollTop: this.leader.scrollTop - scrollDiff
        });
    }

    jump(e){
        const separator = e.target;
        let floorTarget;

        if (separator.classList.contains('max__separator')){

            floorTarget = this.getFloorBtn(settingsData.currentFloor + this.visibleBtnsCount);

            if (!floorTarget){
                floorTarget = this.getFloorBtn(Math.max(...Object.values(this.floors)) - 1);
            }


        } else if (separator.classList.contains('min__separator')){
            floorTarget = this.getFloorBtn(settingsData.currentFloor - this.visibleBtnsCount);

            if (!floorTarget){
                floorTarget = this.getFloorBtn(Math.min(...Object.values(this.floors)));
            }
        }

        this.click(floorTarget);
    }

    getElementHeight(elementClass){
        return document.querySelector(`.${elementClass}`) ? window.innerHeight - document.querySelector(`.${elementClass}`).getBoundingClientRect().top : 0;
    }

    remove(){
        this.leader.removeEventListener('scroll',this.scrollHandler);
        this.leader.removeEventListener('click',this.clickHandler);
        this.scrollHandler = null;
        this.clickHandler = null;
        this.slider.remove();
        this.floors = [];
        this.isScrolling = null;
        this.slider = null;
        this.leader = null;
        this.blockFloorSLider = false;
        this.rightNavBar.classList.remove('fs-slider-open');
    }

    scroll(){
        if (this.blockFloorSLider) return;

        if (this.isScrolling !== null){
            clearTimeout(this.isScrolling);
            this.isScrolling = null;
        }

        if (userPrevent()) return;

        this.rangeBtnToggle();

        enableOrbitControls(false);

        this.isScrolling = setTimeout(()=>{

            for (let number of this.leader.children){

                const scrollDiff = this.leader.scrollTop + this.plugHeight - number.offsetTop;

                if (scrollDiff < this.floorBtnHalfHeight ) {
                    const floor = Number(number.getAttribute('data-floor'));
                    this.setActiveFloorNumber();
                    this.setActiveFloorNumber(number);

                    gsap.to(this.leader,{
                        duration: .3,
                        scrollTop: this.leader.scrollTop - scrollDiff
                    });

                    this.isScrolling = null;
                    this.block();
                    this.changeFloor(floor);
                    return;
                }
            }
        },300);

    }

    getFloorBtn(floor){
        return this.leader.querySelector(`.fs__floor__number[data-floor="${floor}"]`);
    }

    setActiveFloorNumber(element){
        if (!element){
            const getPrevActiveNumber = this.leader.querySelector('.fs__active__floor');
            getPrevActiveNumber && getPrevActiveNumber.classList.remove('fs__active__floor');
            return;
        }

        element.classList.add('fs__active__floor');
    }

    rangeBtnToggle(){
        const fsMinFloorBtn = this.getFloorBtn(this.floors[this.floors.length - 1]);
        const fsMaxFloorBtn = this.getFloorBtn(this.floors[0]);

        const maxBtnDiff = Math.abs(this.leader.scrollTop + this.plugHeight - fsMaxFloorBtn.offsetTop) - this.floorBtnHalfHeight;
        const minBtnDiff = Math.abs(this.leader.scrollTop + this.plugHeight - fsMinFloorBtn.offsetTop) - this.floorBtnHalfHeight;

        if (maxBtnDiff < this.plugHeight){
            this.maxFloorBtn.classList.add('fs__hide__btn');
            this.maxSeparator.classList.add('fs__hide__btn');
        } else {
            this.maxFloorBtn.classList.remove('fs__hide__btn');
            this.maxSeparator.classList.remove('fs__hide__btn');
        }

        if (minBtnDiff < this.plugHeight){
            this.minFloorBtn.classList.add('fs__hide__btn');
            this.minSeparator.classList.add('fs__hide__btn');
        } else {
            this.minFloorBtn.classList.remove('fs__hide__btn');
            this.minSeparator.classList.remove('fs__hide__btn');
        }

    }

    click(floorBtn){
        if (this.blockFloorSLider) return;

        const target = (floorBtn instanceof HTMLElement) ? floorBtn : floorBtn.target;

        if (!target.classList.contains('fs__floor__number')) return;

        target.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
        });

        this.rangeBtnToggle();
    }

    changeFloor(selectedFloor){

        if (selectedFloor < settingsData.currentFloor) {
            projectMode.FloorPlan.down(selectedFloor);
            isMobile ? UnitCardClass.closeMobileCard() : UnitCardClass.closeMultipleCards();
        } else if (selectedFloor > settingsData.currentFloor) {
            projectMode.FloorPlan.up(selectedFloor);
            isMobile ? UnitCardClass.closeMobileCard() : UnitCardClass.closeMultipleCards();
        } else if (selectedFloor === settingsData.currentFloor) {
            enableOrbitControls(true);
            this.unblock();
        }

    }

    block(){
        this.blockFloorSLider = true;
        this.slider.style.pointerEvents = 'none';
        this.leader.style.touchAction = 'none';
    }

    unblock(){
        this.blockFloorSLider = false;
        this.slider.style.pointerEvents = '';
        this.leader.style.touchAction = '';
    }

    updateScroll(currentFloor){
        // if (isMobile) return;

        const floorBtn = this.getFloorBtn(currentFloor);
        const scrollDiff = this.leader.scrollTop + this.plugHeight - floorBtn.offsetTop;

        this.setActiveFloorNumber();
        this.setActiveFloorNumber(floorBtn);

        gsap.to(this.leader,{
            duration: .5,
            scrollTop: this.leader.scrollTop - scrollDiff,
            onStart: () => this.block(),
            onComplete: () => {
                this.rangeBtnToggle();
                this.unblock();
            }
        });
    }

}
